import React from 'react'

import { classNames } from 'constants/elementIdentifiers'

import { Container, NetworkImage } from './styles'

const Network = ({ isTeacher, studentsCount, addShadow }) => {
    return (
        <Container
            isTeacher={isTeacher}
            studentsCount={studentsCount}
            addShadow={addShadow}
            className={classNames.BAD_NETWORK_CONTAINER}
        >
            <NetworkImage
                src={'/assets/revamp/bad-network.svg'}
                alt={'bad-network'}
            />
        </Container>
    )
}

export default Network
